import { useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { AdditionalInformationFormData } from "@/Common/Models/ManualLabResultsEntry/AdditionalInformationFormData";
import { ManualLabResultsEntryFormModel } from "@/Common/Models/ManualLabResultsEntry/ManualLabResultsEntryFormModel";
import { ObservationEntryFormData } from "@/Common/Models/ManualLabResultsEntry/ObservationEntryFromData";
import { ExpandableSection } from "../ExpandableSection";
import { ClinicianSearchStrategy } from "../Search/PersonSearchAutocompleteCustom";
import { AdditionalInformationForm } from "./AdditionalInformationForm";
import { ManualLabResultEntryFormList } from "./ManualLabResultEntryFormList";

import styles from "./ManualLabResultsEntry.module.scss";

interface ManualLabResultsEntryProps {
    data: ManualLabResultsEntryFormModel;
    onChange: (p: ManualLabResultsEntryFormModel) => void;
    clinicianSearchStrategy: ClinicianSearchStrategy;
}

function ManualLabResultsEntry({ data, onChange, clinicianSearchStrategy }: Readonly<ManualLabResultsEntryProps>): JSX.Element {
    const { getText } = useTranslation();

    const [expandAdditionalInformationForm, setExpandAdditionalInformationForm] = useState(true);

    const handleOnAdditionalInformationChange = (mutation: (p: AdditionalInformationFormData) => void): void => {
        mutation(data.addtionalInformationData);
        onChange({ ...data, addtionalInformationData: data.addtionalInformationData });
    };

    return (
        <div data-cy="manual-lab-results-entry" className={styles.manualLabResultEntryContainer}>
            <ExpandableSection
                dataCy="expandable-additional-information-form"
                isOpen={expandAdditionalInformationForm}
                title={getText("ManualResults_AdditionalInformationLabel")}
                onChevronClick={() => setExpandAdditionalInformationForm(expandValue => !expandValue)}
                variant="brand"
                category="primary"
            >
                <AdditionalInformationForm
                    data={data.addtionalInformationData}
                    dataCy="additional-information-form"
                    onChange={p => handleOnAdditionalInformationChange(p)}
                    clinicianSearchStrategy={clinicianSearchStrategy}
                />
            </ExpandableSection>
            <ManualLabResultEntryFormList
                data={data.observations}
                onChange={(p: ObservationEntryFormData[]) => onChange({ ...data, observations: p })}
            />
        </div>
    );
}

export { ManualLabResultsEntry };
